import React from "react";
import styles from "./Tab.module.scss";

const TabBody: React.FC = ({ children }) => {
  return <div className={styles["tab-body"]}>{children}</div>;
};

export default TabBody;
